enum ContextEnum {
	HOME = 'home',
}

enum ChannelEnum {
	SITE = 'site',
}

enum PlacementNameEnum {
	SITE_LOGGED_HOME = 'site_logged_home_com_banner',
}

enum PlacementTypeEnum {
	BANNER = 'banner',
}

enum PlacementSizeEnum {
	STANDARD = '1024x350',
}

enum SegmentationKeyEnum {
	STATE = 'STATE',
	CITY = 'CITY',
	GENDER = 'GENDER',
	AGE = 'AGE',
	AUDIENCES = 'AUDIENCES',
}

enum SellerIdEnum {
	INSTITUTIONAL = 'institucional',
	COMMERCIAL = 'bid_comercial',
}

enum UserTypeEnum {
	FINANCIAL_RESPONSIBLE = 'responsável financeiro',
}

enum ProductTypeEnum {
	PPO = 'PPO',
	HMO = 'HMO',
}

const BANNERS_V2_CONSTANTS = {
	CONTEXT: ContextEnum.HOME,
	CHANNEL: ChannelEnum.SITE,
	PLACEMENT_NAME: PlacementNameEnum.SITE_LOGGED_HOME,
	PLACEMENT_TYPE: PlacementTypeEnum.BANNER,
	PLACEMENT_SIZE: PlacementSizeEnum.STANDARD,
	SEGMENTATION_KEYS: SegmentationKeyEnum,
	SELLER_IDS: SellerIdEnum,
} as const;

const PLACEMENT_QUANTITY = 5;

export {BANNERS_V2_CONSTANTS, PLACEMENT_QUANTITY, ProductTypeEnum, UserTypeEnum};
